import { useState } from 'react'
import { useT } from '../hooks'
import { requestRefresh } from '../cache'
import BBookIcon from './BBookIcon'

// One button for every figure on the screen: live components poll now, reports reload, and the server's short cache is read through.
const BBookRefresh = () => {
  const { t } = useT()
  const [spinning, setSpinning] = useState(false)

  const refresh = () => {
    requestRefresh()
    setSpinning(true)
    setTimeout(() => setSpinning(false), 1200)
  }

  return (
    <button type='button' className={`b_book_refresh ${spinning ? 'b_book_refresh_spinning' : ''}`} onClick={refresh} aria-label={t('pages.b_book.refresh_label')} title={t('pages.b_book.refresh_label')}>
      <BBookIcon name='refresh' size={16} />
      <span>{t('pages.b_book.refresh')}</span>
    </button>
  )
}

export default BBookRefresh
